import { Component, OnDestroy, OnInit, inject, input, output as output_1, output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Filters } from '../filters';
import { SingleSelectPropFilterComponent } from '../single-select-prop-filter/single-select-prop-filter.component';
import { MultiSelectPropFilterComponent } from '../multi-select-prop-filter/multi-select-prop-filter.component';
import { CheckboxPropFilterComponent } from '../checkbox-prop-filter/checkbox-prop-filter.component';

@Component({
    selector: 'app-prop-filter',
    styles: ['form > * {margin-bottom: 1em}'],
    template: `
    @if (propsForm !== undefined) {
      <section class="my-3">
        <form>
          @for (prop of props(); track prop) {
            <div>
              <section id="form-children">
                @switch (prop.type) {
                  @case ('single-select') {
                    <app-single-select-prop-filter
                      (changes)="onChange($event)"
                      [values]="prop.values"
                      [formName]="prop.key"
                      [formGroup]="propsForm"
                    ></app-single-select-prop-filter>
                  }
                  @case ('multi-select') {
                    <app-multi-select-prop-filter
                      (changes)="onChange($event)"
                      [values]="prop.values"
                      [formName]="prop.key"
                      [formGroup]="propsForm"
                    ></app-multi-select-prop-filter>
                  }
                  @case ('radio-select') {
                    <app-checkbox-prop-filter
                      (changes)="onChange($event)"
                      [values]="prop.values"
                      [formName]="prop.key"
                      [formGroup]="propsForm"
                      >
                    </app-checkbox-prop-filter>
                  }
                }
              </section>
            </div>
          }
        </form>
      </section>
    }
    `,
    imports: [FormsModule, SingleSelectPropFilterComponent, ReactiveFormsModule, MultiSelectPropFilterComponent, CheckboxPropFilterComponent]
})
export class PropFilterComponent<T> implements OnInit, OnDestroy {
  private fb = inject(UntypedFormBuilder);

  readonly props = input<Filters.Prop<T>[]>([]);

  readonly propsChange = output<string>();

  readonly formValue = input.required<any>();

  readonly formValueChange = output<any>();

  _props = new Map<string, string>();

  propsForm!: UntypedFormGroup;

  private sub!: Subscription;

  ngOnInit(): void {
    // create a formGroup from input
    this.propsForm = this.fb.group(this.buildFormGroupFromInput());
    this.propsForm.patchValue(this.formValue());

    const formSub = this.propsForm.valueChanges.subscribe((formValues) => {
      this.formValueChange.emit(formValues);
    });
    this.sub = formSub;
  }

  // filter={"roles": {"$in": ["nativa"]}, "tenant": "acme"}
  onChange(value: any) {
    const key = Object.keys(value)[0];
    const val = value[key];

    this._props.set(key, val);

    const output = Array.from(this._props.entries())
      .map(([key, val]) => `"${key}":${val}`)
      .join(',');

    this.propsChange.emit(output);
  }

  /* 
    [
      {key: '_id', type: 'toggle', values: [true, false]},
      ...
    ]

    ===>  
    {
      _id: [null],
      ...
    }
  */
  private buildFormGroupFromInput() {
    return this.props().reduce((prev, current) => {
      return { ...prev, [current.key]: [null] };
    }, {});
  }

  public resetFilters() {
    this.propsForm.reset();
    this.propsChange.emit('');
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
